<template>
    <div :class="'img-' + size" class="custom-icon">
		<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M112 32v91a5 5 0 01-5 5H23a5 5 0 01-5-5V7a5 5 0 015-5h60l29 30zm0 0H83V2" class="path" stroke="#0C2340"/><path d="M34.5 103h30m-30-14h60m-60-14h60m-60-14h60m-60-14h60m-60-14H65" class="highlight" stroke="#00BBDC"/></g></svg>
    </div>
</template>

<script>
    export default {
        props: {
            size: {
                type: String,
                default: '4x'
            }
        }
    }
</script>